import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
// import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
// import CreateIcon from '@material-ui/icons/Create';
// import Button from '@material-ui/core/Button';
// import moment from 'moment';
//Import custom table cell
import CustomTableCell from '../models/table/CustomTableCell';
import {
  presentDate,
  presentFormatedData,
} from '../functionalComponents/dataFormatFunctions';
import { useSelector } from 'react-redux';

// const useStyles = makeStyles((theme) => ({
//   table: {
//     overflowY: 'scroll',
//     [theme.breakpoints.up('md')]: {
//       overflowX: 'none',
//     },
//   },
//   maintitle: {
//     fontWeight: 500,
//     fontSize: '1.2rem',
//     textAlign: 'center',
//     paddingBottom: '0.5rem',
//   },
//   child: {
//     paddingTop: '4rem',
//   },
//   font: {
//     fontWeight: 500,
//     // padding: '0.5rem 0.5rem 0.5rem 0rem',
//     textAlign: 'initial',
//   },
//   fontPadding: {
//     // padding: '0.5rem 0.5rem 0.5rem 0rem',
//     textAlign: 'initial',
//     overflow: 'auto',
//   },
//   button: {
//     backgroundColor: 'transparent',
//     textAlign: 'end',
//     paddingBottom: '2rem',
//     paddingTop: '2rem',
//     [theme.breakpoints.down('xs')]: {
//       textAlign: 'initial',
//       display: 'none',
//     },
//     [theme.breakpoints.down('sm')]: {
//       textAlign: 'end',
//       paddingTop: '2rem',
//     },
//   },
//   grid: {
//     paddingBottom: '2rem',
//     paddingRight: '1.5rem',
//     paddingTop: '2rem',
//   },
//   button2: {
//     backgroundColor: 'transparent',
//     textAlign: 'end',
//     paddingBottom: '2rem',
//     paddingTop: '2rem',
//     [theme.breakpoints.up('sm')]: {
//       // textAlign: 'initial',
//       display: 'none',
//     },
//   },
//   scrollContainer: {
//     overflowX: 'visible',
//   },
// }));

const useStyles = makeStyles((theme) => ({
  table: {
    borderCollapse: 'collapse',
    width: '100%',
    '& th, & td': {
      // border: '1px solid #C6C6C6',
      padding: '8px 12px',
      fontSize: '0.875rem',
      textAlign: 'left',
      // whiteSpace: 'nowrap',
    },
    '& th': {
      backgroundColor: '#F4F4F4',
      fontWeight: 600,
      color: '#333',
    },
    '& tr:nth-of-type(even)': {
      backgroundColor: '#FAFAFA',
    },
    '& tr:hover': {
      backgroundColor: '#F1F1F1',
    },
  },
  maintitle: {
    fontWeight: 600,
    fontSize: '1.2rem',
    textAlign: 'center',
    marginBottom: '1rem',
  },
  scrollContainer: {
    overflowX: 'auto',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
  },
  font: {
    fontWeight: 500,
    textAlign: 'initial',
  },
  fontPadding: {
    textAlign: 'initial',
    overflow: 'auto',
  },
  grid: {
    paddingBottom: '1.5rem',
    paddingRight: '1rem',
    paddingTop: '1.5rem',
  },
  button: {
    textAlign: 'end',
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  button2: {
    textAlign: 'end',
    paddingTop: '1.5rem',
    paddingBottom: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
}));

export default function PoTableQaApproval({ children, ...props }) {
  // const dateFormat = localStorage.selectedDateFormat
  //   ? localStorage.selectedDateFormat
  //   : 'DD/MMM/YYYY';

  const classes = useStyles();
  // const scheduleDateFlag = useSelector((state) => {
  //   if (state.pcmp.common.reports.rmpmGrnFeatures?.status) {
  //     return state.pcmp.common.reports.rmpmGrnFeatures.data.features
  //       .scheduledDeliveryDate;
  //   }
  //   return false;
  // });

  // const lorryReceiptDateEnabled = useSelector((state) => {
  //   if (state.pcmp.common.reports.rmpmGrnFeatures?.status) {
  //     return state.pcmp.common.reports.rmpmGrnFeatures.data.features
  //       .lorryReceiptDateEnabled;
  //   }
  //   return false;
  // });

  const {
    // errors,
    // handleOpenDialog,
    // isRecievedExits,
    // isTableExists,
    POLineRecordDetails,
    POBatchRecordDetails,
    receivedQuantityInfo,
    asnDetails,
    qualityAssuranceInfo,
  } = props;

  const { minShelfLife, shelfLifeUnitIndicator } = props?.POLineRecordDetails;

  return (
    <React.Fragment>
      <Typography variant='h4' className={classes.maintitle}>
        Selected Record
      </Typography>
      <TableContainer className={classes.scrollContainer}>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>PO/STO No.</TableCell>
              <TableCell>PO Date</TableCell>
              <TableCell>ASN No.</TableCell>
              <TableCell>Batch No.</TableCell>
              {/* {scheduleDateFlag && <TableCell>Sch. Delivery Date</TableCell>} */}
              <TableCell>Material type</TableCell>

              <TableCell>Material Code / Description</TableCell>
              <TableCell>UOM</TableCell>
              <TableCell align='right'>GRN Quantity</TableCell>
              <TableCell>GRN No.</TableCell>
              <TableCell>Delivery Tolerance</TableCell>
              <TableCell>Shelf Life</TableCell>
              <TableCell>Supplier Name</TableCell>
              <TableCell>Current Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow style={{ border: '2px solid #C6C6C6' }}>
              <CustomTableCell align=''>
                {presentFormatedData(
                  POLineRecordDetails.supplierPurchaseOrderNumber,
                  '-'
                )}
              </CustomTableCell>
              <CustomTableCell>
                {presentDate(POLineRecordDetails.supplierPODate, '-')}
              </CustomTableCell>
              <CustomTableCell>
                {presentFormatedData(asnDetails?.asnNumber, '-')}
              </CustomTableCell>
              <CustomTableCell>
                {presentFormatedData(
                  qualityAssuranceInfo.analyticalReportNumber,
                  '-'
                )}
              </CustomTableCell>
              <CustomTableCell>
                {POLineRecordDetails.materialType === 'ROH'
                  ? 'RM'
                  : POLineRecordDetails.materialType === 'VERP'
                  ? 'PM'
                  : POLineRecordDetails.materialType}
              </CustomTableCell>

              <CustomTableCell elementStyle={{ whiteSpace: 'normal' }}>{`${
                POLineRecordDetails.materialCode
              } /${''}
                      ${POLineRecordDetails.materialName}`}</CustomTableCell>

              <CustomTableCell>
                {POLineRecordDetails.unitOfMeasurementOrdered}
              </CustomTableCell>
              <CustomTableCell>
                {receivedQuantityInfo.actualQuantityReceived}
              </CustomTableCell>
              <CustomTableCell>
                {presentFormatedData(POBatchRecordDetails.numberGRN, '-')}
              </CustomTableCell>
              <CustomTableCell>
                {POLineRecordDetails.overDeliveryTolerance === '' ||
                POLineRecordDetails.overDeliveryTolerance === null ||
                POLineRecordDetails.overDeliveryTolerance === undefined
                  ? '-'
                  : POLineRecordDetails.overDeliveryTolerance}
              </CustomTableCell>
              <CustomTableCell>
                {minShelfLife
                  ? `${presentFormatedData(
                      minShelfLife
                    )}${' '}${presentFormatedData(shelfLifeUnitIndicator)}`
                  : 'NA'}
              </CustomTableCell>
              <CustomTableCell>
                {POLineRecordDetails.supplierName}
              </CustomTableCell>

              <CustomTableCell>
                {POBatchRecordDetails.batchStatusText}
              </CustomTableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* {isRecievedExits ? (
        <Grid container>
          {localStorage.getItem('collabType') !== 'Pharma Co' &&
          (props.status !== 3 || props.status === 13) ? (
            <Grid item xs={12} sm={4} md={8} className={classes.button2}>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                onClick={() => handleOpenDialog('openPOItem')}
              >
                Edit
              </Button>
            </Grid>
          ) : null}
          <Grid item xs={12} sm={6} md={3} className={classes.grid}>
            <Typography variant='body2' className={classes.font}>
              MRN Number
            </Typography>
            {POBatchRecordDetails.numberMRN === '' ||
            POBatchRecordDetails.numberMRN === null ? (
              <Typography
                variant='body2'
                className={classes.fontPadding}
                color='error'
              >
                -Not provided-
              </Typography>
            ) : (
              <Typography
                variant='body2'
                className={classes.fontPadding}
                color={errors.numberGRN ? 'error' : 'inherit'}
              >
                {POBatchRecordDetails.numberMRN}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={3} className={classes.grid}>
            <Typography variant='body2' className={classes.font}>
              Date material was received
            </Typography>

            {POBatchRecordDetails.materialReceivedDate === null ? (
              <Typography
                variant='body2'
                className={classes.fontPadding}
                color='error'
              >
                -Not provided-
              </Typography>
            ) : (
              <Typography
                variant='body2'
                className={classes.fontPadding}
                color={errors.materialReceivedDate ? 'error' : 'inherit'}
              >
                {moment(POBatchRecordDetails.materialReceivedDate).format(
                  dateFormat
                )}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={3} className={classes.grid}>
            <Typography variant='body2' className={classes.font}>
              Transporter Name (optional)
            </Typography>
            <Typography variant='body2' className={classes.fontPadding}>
              {POBatchRecordDetails.transporterName === ''
                ? '-Not Provided-'
                : POBatchRecordDetails.transporterName}
            </Typography>
          </Grid>

          {localStorage.getItem('collabType') !== 'Pharma Co' &&
          props.status !== 3 ? (
            <Grid item xs={12} sm={6} md={3} className={classes.button}>
              <Button
                variant='contained'
                startIcon={<CreateIcon fontSize='small' />}
                style={{
                  backgroundColor: 'transparent',
                  boxShadow: 'none',
                  border: '1px solid #000000de',
                }}
                size='small'
                onClick={() => handleOpenDialog('openPOItem')}
              >
                Edit
              </Button>
            </Grid>
          ) : null}

          <Grid item xs={12} sm={8} md={3} className={classes.grid}>
            <Typography variant='body2' className={classes.font}>
              Lorry Receipt (LR) Number (optional)
            </Typography>
            <Typography variant='body2' className={classes.fontPadding}>
              {presentFormatedData(
                POBatchRecordDetails.lorryReceiptNumber,
                '-Not Provided-'
              )}
            </Typography>
          </Grid>
          {lorryReceiptDateEnabled && (
            <Grid item xs={12} sm={8} md={3} className={classes.grid}>
              <Typography variant='body2' className={classes.font}>
                Lorry Receipt (LR) Date (optional)
              </Typography>
              <Typography variant='body2' className={classes.fontPadding}>
                {presentDate(
                  POBatchRecordDetails.lorryReceiptDate,
                  '-Not Provided-'
                )}
              </Typography>
            </Grid>
          )}
        </Grid>
      ) : null} */}
    </React.Fragment>
  );
}
